<template>
  <div style="margin: 15px">
    <template v-if="data && data.ctrlType == 'grid'">
      <eco-form-item label="栅格间隔" label-width="65px">
        <eco-input
          type="number"
          v-model="data.options.gutter"
          size="mini"
          width="156px"
        >
          <template slot="append">
            <span>px</span>
          </template>
        </eco-input>
      </eco-form-item>
      <eco-form-item label-width="65px">
        <template slot="label">
          <el-tooltip
            content="一行被切分为24分栏，通过列配置可以将一行划分为多列，每一列指定包含几个分栏。"
          >
            <i class="property-tip icon-question" />
          </el-tooltip>
          <span>列配置</span>
        </template>
        <draggable
          tag="ul"
          class="column-ul"
          :list="data.columns"
          v-bind="{
            group: { name: 'options' },
            ghostClass: 'ghost',
            handle: '.drag-item'
          }"
          handle=".drag-item"
        >
          <li v-for="(item, index) in data.columns" :key="index">
            <i class="drag-item icon-draggable"></i>
            <eco-input
              size="mini"
              width="130px"
              :min="0"
              :max="24"
              type="number"
              v-model.number="item.span"
            />
            &nbsp;&nbsp;<el-button
              type="text"
              @click="handleGridColumnStyle(index)"
              >样式</el-button
            >
            <el-button
              @click="handleGridColumnRemove(index)"
              circle
              plain
              class="grid-remove-button"
              type="danger"
              size="mini"
              icon="el-icon-minus"
            ></el-button>
          </li>
        </draggable>
        <div style="margin-left: 22px;">
          <el-button type="text" @click="handleGridColumnAdd"
            >添加一列</el-button
          >
        </div>
      </eco-form-item>
      <eco-form-item label="横向排列" label-width="65px">
        <eco-select
          v-model="data.options.justify"
          :options="[
            { key: 'start', value: '左对齐' },
            { key: 'end', value: '右对齐' },
            { key: 'center', value: '居中' },
            { key: 'space-around', value: '两侧间隔相等' },
            { key: 'space-between', value: '两端对齐' }
          ]"
        />
      </eco-form-item>
      <eco-form-item label="纵向排列" label-width="65px">
        <eco-select
          v-model="data.options.align"
          :options="[
            { key: 'top', value: '顶部对齐' },
            { key: 'middle', value: '居中' },
            { key: 'bottom', value: '底部对齐' }
          ]"
        />
      </eco-form-item>
    </template>

    <!--table选项卡配置-->
    <template v-else-if="data && data.ctrlType == 'tab'">
      <eco-form-item label-width label="风格类型">
        <el-radio-group v-model="data.options.type">
          <el-radio-button label>默认</el-radio-button>
          <el-radio-button label="card">选项卡</el-radio-button>
          <el-radio-button label="border-card">卡片化</el-radio-button>
        </el-radio-group>
      </eco-form-item>
      <eco-form-item label-width label="选项卡位置">
        <el-radio-group v-model="data.options.align">
          <el-radio-button label="top">顶部</el-radio-button>
          <el-radio-button label="left">左侧</el-radio-button>
          <el-radio-button label="right">右侧</el-radio-button>
          <el-radio-button label="bottom">底部</el-radio-button>
        </el-radio-group>
      </eco-form-item>
      <eco-form-item label-width>
        <eco-checkbox
          v-model="data.options.nextCheck"
          :options="[{ key: 'true', value: '页签、切换前是否校验当前页' }]"
        />
      </eco-form-item>
      <eco-form-item label-width label="标签配置项">
        <draggable
          tag="ul"
          class="column-ul"
          :list="data.columns"
          v-bind="{
            group: { name: 'options' },
            ghostClass: 'ghost',
            handle: '.drag-item'
          }"
          handle=".drag-item"
        >
          <li v-for="(item, index) in data.columns" :key="index">
            <i class="drag-item icon-draggable"></i>
            <eco-input size="mini" width="130px" v-model="item.span" />
            <el-button
              @click="handleGridColumnRemove(index)"
              circle
              plain
              class="grid-remove-button"
              type="danger"
              size="mini"
              icon="el-icon-minus"
            ></el-button>
          </li>
        </draggable>
        <div style="margin-left: 22px;">
          <el-button type="text" @click="handleGridColumnAdd('tab')"
            >添加标签</el-button
          >
        </div>
      </eco-form-item>
    </template>

    <!--分页配置-->

    <template v-else-if="data && data.ctrlType == 'page'">
      <h3>无内容</h3>
    </template>
    <!--分页步骤条-->
    <template v-else-if="data && data.ctrlType == 'pageSteps'">
      <eco-form-item label-width label="是否显示分页步骤条">
        <el-switch
          v-model="data.isShow"
          active-color="#13ce66"
          inactive-color="#ff4949"
        ></el-switch>
      </eco-form-item>
      <eco-form-item label-width label="分页步骤名配置">
        <li v-for="(item, index) in data.pageStepsArr" :key="index">
          <i class="drag-item icon-draggable"></i>
          <eco-input size="mini" width="130px" v-model="item.name" />
        </li>
      </eco-form-item>
    </template>

    <!--分页按钮配置-->
    <template v-else-if="data && data.ctrlType == 'pageButton'">
      <h1>分页按钮配置:</h1>
      <h3>下一步按钮配置:</h3>
      <eco-form-item label-width label="按钮名">
        <eco-input v-model="data.nextButton.name" />
      </eco-form-item>

      <eco-form-item label-width label="按钮图标">
        <div
          style="float: right;
  margin-right: 15px;"
        >
          <IconDialog @selected="pegeNextIcon" />
        </div>
      </eco-form-item>
      <eco-form-item label-width label="按钮颜色">
        <div style="height: 0px;margin-top:10px;margin-bottom:20px;">
          <el-color-picker
            v-model="data.nextButton.color"
            size="mini"
          ></el-color-picker>
        </div>
      </eco-form-item>
      <!-- <eco-form-item label-width label="按钮前置脚本">
        <eco-input v-model="data.nextButton.preScript" />
        <el-button class="btn-padding" icon="el-icon-plus" @click="autoRunJSScript(1,true)">设置自定义脚本</el-button>
      </eco-form-item>
      <eco-form-item label-width label="按钮后置脚本">
        <eco-input v-model="data.nextButton.rearScript" />
      </eco-form-item>-->
      <h3>上一步按钮配置:</h3>
      <eco-form-item label-width label="按钮名">
        <eco-input v-model="data.backButton.name" />
      </eco-form-item>

      <eco-form-item label-width label="按钮图标">
        <div
          style="float: right;
  margin-right: 15px;"
        >
          <IconDialog @selected="pegeBackIcon" />
        </div>
      </eco-form-item>
      <eco-form-item label-width label="按钮颜色">
        <div style="height: 0px;margin-top:10px;margin-bottom:20px;">
          <el-color-picker
            v-model="data.backButton.color"
            size="mini"
          ></el-color-picker>
        </div>
      </eco-form-item>
      <el-dialog
        title="按钮脚本"
        :visible.sync="pageBtnScriptDialog"
        append-to-body
        class="urgent-text"
        :before-close="pageBtnScriptDialogOk"
        :close-on-click-modal="false"
        width="600px"
      >
        <el-row style="height:100%">
          <textarea
            v-model="pageBtnScriptBase"
            type="textarea"
            rows="30"
            autocomplete="off"
            ref="scriptText"
            style="width: 99%;height:100%;"
          ></textarea>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="pageBtnScriptDialogClose">取 消</el-button>
          <el-button type="primary" @click="pageBtnScriptDialogOk"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </template>

    <!--折叠面板配置-->
    <template v-else-if="data && data.ctrlType == 'accordion'">
      <eco-form-item label-width label="折叠面板配置">
        <!--<eco-checkbox v-model="data.options.accordion" :options="[{key: 'true', value: '是否手风琴模式'}]" />-->
        <eco-checkbox
          v-model="data.options.nextCheck"
          :options="[{ key: 'true', value: '面板、折叠前是否校验当前面板' }]"
        />
      </eco-form-item>

      <eco-form-item label-width label="面板配置">
        <draggable
          tag="ul"
          class="column-ul"
          :list="data.columns"
          v-bind="{
            group: { name: 'options' },
            ghostClass: 'ghost',
            handle: '.drag-item'
          }"
          handle=".drag-item"
        >
          <li v-for="(item, index) in data.columns" :key="index">
            <i class="drag-item icon-draggable"></i>
            <eco-input size="mini" width="130px" v-model="item.span" />
            <el-switch
              v-model="item.isOpen"
              @change="switchChange(item)"
              active-text="是否展开"
              inactive-value="false"
              active-value="true"
              style="margin-left: 10px"
            ></el-switch>
            <el-button
              @click="handleGridColumnRemove(index)"
              style="margin-left: 10px"
              circle
              plain
              class="grid-remove-button"
              type="danger"
              size="mini"
              icon="el-icon-minus"
            ></el-button>
          </li>
        </draggable>
        <div style="margin-left: 22px;">
          <el-button type="text" @click="handleGridColumnAdd('collapse')"
            >添加面板</el-button
          >
        </div>
      </eco-form-item>
    </template>

    <!--子表配置-->
    <template
      v-else-if="
        data &&
          (data.ctrlType == 'subtable' ||
            data.ctrlType == 'tableRowLayout' ||
            data.ctrlType == 'subDiv')
      "
    >
      <eco-form-item label-width label="绑定子表">
        <eco-select
          v-model="data.options.boSubEntity"
          :options="subTables"
          :props="{ key: 'name', value: 'desc' }"
          @change="subTableChange"
        ></eco-select>
      </eco-form-item>
      <eco-form-item label-width label="子表标题">
        <eco-input v-model="data.desc" style="width: 215px">
          <el-button
            icon="el-icon-search"
            slot="append"
            @click="editI18nMessage"
            >国际化</el-button
          >
        </eco-input>
      </eco-form-item>
      <el-tooltip>
        <template slot="content">
          1：可从引入脚本处复制头部thead标签中行tr所有数据作为二级头部信息<br />
          2：参照复制的二级头部数据，进行td标签的修改合并为一级头部<br />
        </template>
        <el-button icon="icon-technology" size="mini" @click="includdingFile"
          >自定义表头</el-button
        >
      </el-tooltip>
      <el-button @click="addRelation">添加关联关系</el-button>
      <div style="margin-top:10px;margin-bottom:10px;">
        <el-tooltip
          content="需先配置自定义对话框，实现效果：配置子表回填后会在子表上显示配置的按钮，点击后弹出对话框，选择数据将已选数据回填到子表中。"
        >
          <i class="property-tip icon-question" />
        </el-tooltip>
        <el-checkbox v-model="data.subtableBackfill">子表回填</el-checkbox>
      </div>
      <fe-load-data
        url="/form/customDialog/v1/getAll"
        requestMethod="post"
        context="form"
        @after-load-data="afterCustomDialogLoadData"
      ></fe-load-data>
      <span v-if="data.subtableBackfill">
        <div class="custDialog-div">
          <el-button
            class="custDialog-btn"
            v-if="data.customDialogjson.custDialog.alias"
            icon="icon-list2"
            size="mini"
            @click="custDialogClick"
            >设置返回值</el-button
          >
        </div>

        <eco-form-item
          label-width="100px"
          class="customQuery-inputs custDialog-item"
        >
          <template slot="label">
            <el-tooltip content="所选择的自定义查询作为选项时的绑定">
              <i class="property-tip icon-question" />
            </el-tooltip>
            <span>选择对话框</span>
          </template>
          <eco-select
            filterable
            clearable
            @change="changeCustDialog"
            v-model="data.customDialogjson.custDialog.alias"
            :options="customDialogs"
            :props="{ key: 'alias', value: 'name' }"
          />
        </eco-form-item>
        <!-- 参数绑定 -->
        <div
          class="basics-property"
          v-if="
            data.customDialogjson.custDialog.conditions &&
              data.customDialogjson.custDialog.conditions.length > 0
          "
        >
          <eco-form-item>
            <template slot="label">
              <el-tooltip content="自定义对话框需要的参数传入">
                <i class="property-tip icon-question" />
              </el-tooltip>
              <span>参数绑定</span>
            </template>
          </eco-form-item>
        </div>
        <table
          v-if="
            data.customDialogjson.custDialog.conditions &&
              data.customDialogjson.custDialog.conditions.length > 0
          "
          class="form-table custDialog-table"
          cellspacing="0"
          cellpadding="0"
          border="0"
        >
          <tbody>
            <tr class="linkageTable-tr">
              <td width="100px;">参数名</td>
              <td>取值对象</td>
              <!-- <td>默认值</td> -->
            </tr>
            <tr
              class="linkageTable-tr"
              v-for="(condition, indexCondition) in data.customDialogjson
                .custDialog.conditions"
              :key="indexCondition"
            >
              <td>{{ condition.comment }}</td>
              <td>
                <eco-select
                  validate="required"
                  v-model="condition.bind"
                  :options="tablefields.filter(tab => tab.type == 'main')"
                  :props="{ key: 'name', value: 'desc' }"
                  :clearable="true"
                >
                  <template slot-scope="{ options }">
                    <el-option-group
                      v-for="group in options"
                      :key="group.name"
                      :label="group.desc"
                    >
                      <el-option
                        v-for="item in group.children"
                        :key="item.id"
                        :label="item.desc"
                        :value="'data.' + item.path + '.' + item.name"
                      ></el-option>
                    </el-option-group>
                  </template>
                </eco-select>
              </td>
            </tr>
          </tbody>
        </table>
        <eco-form-item
          label="按钮名称"
          label-width="100px"
          class="customQuery-inputs custDialog-item"
        >
          <eco-input v-model="data.customDialogjson.name"></eco-input>
        </eco-form-item>

        <div class="custDialog-div">
          <span>按钮图标</span>
          <div
            style="float: right;
  margin-right: 15px;"
          >
            <IconDialog @selected="icons" />
          </div>
          <i
            :class="this.data.customDialogjson.icon"
            style="float: right; line-height: 28px"
          ></i>
        </div>
      </span>
      <el-dialog
        title="设置对话框返回值"
        :visible.sync="dialogcustDialogVisible"
        append-to-body
        class="urgent-text"
        :close-on-click-modal="false"
        width="600px"
      >
        <el-table
          :data="data.customDialogjson.resultField"
          class="form-table"
          cellspacing="0"
          cellpadding="0"
          border="0"
          height="600px"
        >
          <el-table-column label="返回结果字段" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.comment }}
            </template>
          </el-table-column>
          <el-table-column label="绑定显示的属性" min-width="220">
            <template slot-scope="scope">
              <eco-select
                filterable
                v-model="custDialogprop[scope.row.comment]"
                :options="
                  subTables.filter(
                    item => item.name === data.options.boSubEntity
                  )
                "
                :props="{ key: 'name', value: 'desc' }"
                clearable
              >
                <template slot-scope="{ options }">
                  <el-option-group
                    v-for="(group, idenx) in options"
                    :key="idenx"
                    :label="group.desc"
                  >
                    <el-option
                      v-for="item in group.children"
                      :key="item.id"
                      :label="item.desc"
                      :value="item.path + '.' + item.name"
                    ></el-option>
                  </el-option-group>
                </template>
              </eco-select>
            </template>
          </el-table-column>
          <el-table-column label="解除绑定" min-width="80">
            <template slot-scope="scope">
              <el-button
                icon="el-icon-delete"
                @click="unbind(scope.row.comment)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--        <table-->
        <!--          class="form-table"-->
        <!--          cellspacing="0"-->
        <!--          cellpadding="0"-->
        <!--          border="0"-->
        <!--          height="600px"-->
        <!--        >-->
        <!--          <tbody>-->
        <!--            <tr class="linkageTable-tr">-->
        <!--              <td width="150px">返回结果字段</td>-->
        <!--              <td width="220px">绑定显示的属性</td>-->
        <!--              <td width="80px">解除绑定</td>-->
        <!--            </tr>-->

        <!--            <tr-->
        <!--              class="linkageTable-tr"-->
        <!--              v-for="(field, index) in this.data.customDialogjson.resultField"-->
        <!--              :key="index"-->
        <!--            >-->
        <!--              <td>{{ field.comment }}</td>-->
        <!--              <td>-->
        <!--                <eco-select-->
        <!--                  v-model="custDialogprop[field.comment]"-->
        <!--                  :options="-->
        <!--                    subTables.filter(-->
        <!--                      item => item.name === data.options.boSubEntity-->
        <!--                    )-->
        <!--                  "-->
        <!--                  :props="{ key: 'name', value: 'desc' }"-->
        <!--                  clearable-->
        <!--                >-->
        <!--                  <template slot-scope="{ options }">-->
        <!--                    <el-option-group-->
        <!--                      v-for="(group, idenx) in options"-->
        <!--                      :key="idenx"-->
        <!--                      :label="group.desc"-->
        <!--                    >-->
        <!--                      <el-option-->
        <!--                        v-for="item in group.children"-->
        <!--                        :key="item.id"-->
        <!--                        :label="item.desc"-->
        <!--                        :value="item.path + '.' + item.name"-->
        <!--                      ></el-option>-->
        <!--                    </el-option-group>-->
        <!--                  </template>-->
        <!--                </eco-select>-->
        <!--              </td>-->
        <!--              <td>-->
        <!--                <el-button-->
        <!--                  icon="el-icon-delete"-->
        <!--                  @click="unbind(field.comment)"-->
        <!--                ></el-button>-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--          </tbody>-->
        <!--        </table>-->
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="custDialogOk">确 定</el-button>
          <el-button @click="dialogcustDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="自定义表头"
        :visible.sync="dialogincluddingFileVisible"
        append-to-body
        class="urgent-text"
        :before-close="includeFilesOk"
        :close-on-click-modal="false"
        width="600px"
      >
        <el-row style="height:100%">
          <textarea
            v-model="data.customHeader"
            type="textarea"
            rows="30"
            autocomplete="off"
            ref="scriptText"
            style="width: 99%;height:100%;"
          ></textarea>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="includeFilesOk">确 定</el-button>
          <el-button
            @click="
              dialogincluddingFileVisible = false;
              data.customHeader = '';
            "
            >取 消</el-button
          >
        </div>
      </el-dialog>
      <i18n-message-edit
        ref="i18nMessageEdit"
        :messageKey="i18nMessageKey"
        @after-save="afterSaveI18n"
      />
    </template>

    <template
      v-else-if="
        data && (data.ctrlType == 'suntable' || data.ctrlType == 'sunDiv')
      "
    >
      <eco-form-item label-width label="绑定孙表">
        <eco-select
          v-model="data.options.boSubEntity"
          :options="sunTables"
          :props="{ key: 'name', value: 'desc' }"
          @change="subTableChange"
        ></eco-select>
      </eco-form-item>
      <eco-form-item label-width label="孙表标题">
        <eco-input v-model="data.desc" style="width: 215px">
          <el-button
            icon="el-icon-search"
            slot="append"
            @click="editI18nMessage"
            >国际化</el-button
          >
        </eco-input>
      </eco-form-item>
      <el-button icon="icon-technology" size="mini" @click="includdingFile"
        >自定义表头</el-button
      >
      <div style="margin-top:10px;margin-bottom:10px;">
        <el-tooltip
          content="需先配置自定义对话框，实现效果：配置子表回填后会在子表上显示配置的按钮，点击后弹出对话框，选择数据将已选数据回填到子表中。"
        >
          <i class="property-tip icon-question" />
        </el-tooltip>
        <el-checkbox v-model="data.subtableBackfill">子表回填</el-checkbox>
      </div>
      <fe-load-data
        url="/form/customDialog/v1/getAll"
        requestMethod="post"
        context="form"
        @after-load-data="afterCustomDialogLoadData"
      ></fe-load-data>
      <span v-if="data.subtableBackfill">
        <div class="custDialog-div">
          <el-button
            class="custDialog-btn"
            v-if="data.customDialogjson.custDialog.alias"
            icon="icon-list2"
            size="mini"
            @click="custDialogClick"
            >设置返回值</el-button
          >
        </div>

        <eco-form-item
          label-width="100px"
          class="customQuery-inputs custDialog-item"
        >
          <template slot="label">
            <el-tooltip content="所选择的自定义查询作为选项时的绑定">
              <i class="property-tip icon-question" />
            </el-tooltip>
            <span>选择对话框</span>
          </template>
          <eco-select
            filterable
            clearable
            @change="changeCustDialog"
            v-model="data.customDialogjson.custDialog.alias"
            :options="customDialogs"
            :props="{ key: 'alias', value: 'name' }"
          />
        </eco-form-item>

        <eco-form-item
          label="按钮名称"
          label-width="100px"
          class="customQuery-inputs custDialog-item"
        >
          <eco-input v-model="data.customDialogjson.name"></eco-input>
        </eco-form-item>

        <div class="custDialog-div">
          <span>按钮图标</span>
          <div
            style="float: right;
  margin-right: 15px;"
          >
            <IconDialog @selected="icons" />
          </div>
          <i
            :class="this.data.customDialogjson.icon"
            style="float: right; line-height: 28px"
          ></i>
        </div>
      </span>
      <el-dialog
        title="设置对话框返回值"
        :visible.sync="dialogcustDialogVisible"
        append-to-body
        class="urgent-text"
        :close-on-click-modal="false"
        width="600px"
      >
        <el-table
          :data="data.customDialogjson.resultField"
          class="form-table"
          cellspacing="0"
          cellpadding="0"
          border="0"
          height="600px"
        >
          <el-table-column label="返回结果字段" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.comment }}
            </template>
          </el-table-column>
          <el-table-column label="绑定显示的属性" min-width="220">
            <template slot-scope="scope">
              <eco-select
                v-model="custDialogprop[scope.row.comment]"
                :options="
                  subTables.filter(
                    item => item.name === data.options.boSubEntity
                  )
                "
                :props="{ key: 'name', value: 'desc' }"
                clearable
              >
                <template slot-scope="{ options }">
                  <el-option-group
                    v-for="(group, idenx) in options"
                    :key="idenx"
                    :label="group.desc"
                  >
                    <el-option
                      v-for="item in group.children"
                      :key="item.id"
                      :label="item.desc"
                      :value="item.path + '.' + item.name"
                    ></el-option>
                  </el-option-group>
                </template>
              </eco-select>
            </template>
          </el-table-column>
          <el-table-column label="解除绑定" min-width="80">
            <template slot-scope="scope">
              <el-button
                icon="el-icon-delete"
                @click="unbind(scope.row.comment)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--        <table class="form-table" cellspacing="0" cellpadding="0" border="0" height="600px">-->
        <!--          <tbody>-->
        <!--            <tr class="linkageTable-tr">-->
        <!--              <td width="150px">返回结果字段</td>-->
        <!--              <td width="220px">绑定显示的属性</td>-->
        <!--              <td width="80px">解除绑定</td>-->
        <!--            </tr>-->

        <!--            <tr-->
        <!--              class="linkageTable-tr"-->
        <!--              v-for="(field, index) in this.data.customDialogjson.resultField"-->
        <!--              :key="index"-->
        <!--            >-->
        <!--              <td>{{ field.comment }}</td>-->
        <!--              <td>-->
        <!--                <eco-select-->
        <!--                  v-model="custDialogprop[field.comment]"-->
        <!--                  :options="-->
        <!--                    subTables.filter(-->
        <!--                      item => item.name === data.options.boSubEntity-->
        <!--                    )-->
        <!--                  "-->
        <!--                  :props="{ key: 'name', value: 'desc' }"-->
        <!--                  clearable-->
        <!--                >-->
        <!--                  <template slot-scope="{ options }">-->
        <!--                    <el-option-group-->
        <!--                      v-for="(group, idenx) in options"-->
        <!--                      :key="idenx"-->
        <!--                      :label="group.desc"-->
        <!--                    >-->
        <!--                      <el-option-->
        <!--                        v-for="item in group.children"-->
        <!--                        :key="item.id"-->
        <!--                        :label="item.desc"-->
        <!--                        :value="item.path + '.' + item.name"-->
        <!--                      ></el-option>-->
        <!--                    </el-option-group>-->
        <!--                  </template>-->
        <!--                </eco-select>-->
        <!--              </td>-->
        <!--              <td>-->
        <!--                <el-button-->
        <!--                  icon="el-icon-delete"-->
        <!--                  @click="unbind(field.comment)"-->
        <!--                ></el-button>-->
        <!--              </td>-->
        <!--            </tr>-->
        <!--          </tbody>-->
        <!--        </table>-->
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="custDialogOk">确 定</el-button>
          <el-button @click="dialogcustDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="自定义表头"
        :visible.sync="dialogincluddingFileVisible"
        append-to-body
        class="urgent-text"
        :before-close="includeFilesOk"
        :close-on-click-modal="false"
        width="600px"
      >
        <el-row style="height:100%">
          <textarea
            v-model="data.customHeader"
            type="textarea"
            rows="30"
            autocomplete="off"
            ref="scriptText"
            style="width: 99%;height:100%;"
          ></textarea>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="includeFilesOk">确 定</el-button>
          <el-button
            @click="
              dialogincluddingFileVisible = false;
              data.customHeader = '';
            "
            >取 消</el-button
          >
        </div>
      </el-dialog>
      <i18n-message-edit
        ref="i18nMessageEdit"
        :messageKey="i18nMessageKey"
        @after-save="afterSaveI18n"
      />
    </template>
    <template v-else-if="data && data.ctrlType == 'dataView'">
      <div class="custDialog-div">
        <span>数据视图设置</span>
        <el-button
          class="custDialog-btn"
          icon="icon-list2"
          size="mini"
          v-if="templateList.length != 0"
          @click="dataViewClick()"
          >设置参数绑定</el-button
        >
      </div>
      <eco-form-item
        label-width="120px"
        class="customQuery-inputs custDialog-item"
      >
        <template slot="label">
          <el-tooltip content="所选择的数据报表作为选项时的绑定">
            <i class="property-tip icon-question" />
          </el-tooltip>
          <span>选择数据报表</span>
        </template>
        <eip-data-template-selector
          v-model="templateList"
          placeholder="请选择数据报表"
          :single="true"
          v-if="templateShow"
        ></eip-data-template-selector>
      </eco-form-item>
      <!-- <div style="margin-top:10px;margin-bottom:10px;" v-if="templateList.length !=0">
        <el-tooltip
          content="配置数据报表回填表单字段数据"
        >
          <i class="property-tip icon-question" />
        </el-tooltip>
        <el-checkbox  v-model="data.subtableBackfill">数据报表回填</el-checkbox>
        <span v-if="data.subtableBackfill">
        <div class="custDialog-div">
          <el-button
            class="custDialog-btn"
            icon="icon-list2"
            size="mini"
            @click="custDialogClick"
            >设置返回值</el-button
          >
        </div>
        </span>
      </div> -->

      <el-dialog
        title="设置数据报表回填"
        :visible.sync="dialogcustDialogVisible"
        append-to-body
        class="urgent-text"
        :close-on-click-modal="false"
        width="600px"
      >
        <table class="form-table" cellspacing="0" cellpadding="0" border="0">
          <tbody>
            <tr class="linkageTable-tr">
              <td width="150px">返回结果字段</td>
              <td width="220px">绑定表单的字段属性</td>
              <td width="80px">解除绑定</td>
            </tr>
            <tr
              class="linkageTable-tr"
              v-for="(field, index) in this.templateField"
              :key="index"
            >
              <td>{{ field.desc }}</td>
              <td>
                <eco-select
                  validate="required"
                  v-model="custDialogprop[field.name]"
                  :options="tablefields"
                  :props="{ key: 'name', value: 'desc' }"
                >
                  <template slot-scope="{ options, propKey, propValue }">
                    <el-option-group
                      v-for="group in options"
                      :key="group.name"
                      :label="group.desc"
                    >
                      <el-option
                        v-for="item in group.children.filter(obj => {
                          return filterFields(obj);
                        })"
                        :key="item[propKey]"
                        :label="item[propValue]"
                        :value="item[propKey]"
                      ></el-option>
                    </el-option-group>
                  </template>
                </eco-select>
              </td>
              <td>
                <el-button
                  icon="el-icon-delete"
                  @click="unbind(field.name)"
                ></el-button>
              </td>
            </tr>
          </tbody>
        </table>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="custDialogOk">确 定</el-button>
          <el-button @click="dialogcustDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="设置数据视图参数"
        :visible.sync="dialogDataViewVisible"
        append-to-body
        class="urgent-text"
        :close-on-click-modal="false"
        width="600px"
      >
        <table class="form-table" cellspacing="0" cellpadding="0" border="0">
          <tbody>
            <tr class="linkageTable-tr">
              <td width="150px">
                <el-tooltip content="绑定主键时，需要启动流程后才有值">
                  <i class="property-tip icon-question" />
                </el-tooltip>
                <span>关联查询字段</span>
              </td>
              <td>
                <eco-select
                  validate="required"
                  v-model="data.options.selectField"
                  :options="tablefields"
                  :props="{ key: 'name', value: 'desc' }"
                  :clearable="true"
                >
                  <template slot-scope="{ options, propKey, propValue }">
                    <el-option-group
                      v-for="group in options"
                      :key="group.name"
                      :label="group.desc"
                    >
                      <el-option
                        v-for="item in group.children.filter(obj => {
                          return filterFields(obj);
                        })"
                        :key="item[propKey]"
                        :label="item[propValue]"
                        :value="item[propKey]"
                      ></el-option>
                      <el-option
                        :key="group.pkKey"
                        label="主键"
                        :value="group.pkKey"
                      ></el-option>
                    </el-option-group>
                  </template>
                </eco-select>
              </td>
              <td>
                <el-select
                  v-model="data.options.bindSelectd"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in templateField"
                    :key="item.id"
                    :label="item.desc"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </td>
            </tr>
            <tr class="linkageTable-tr">
              <td width="150px">
                <el-tooltip content="绑定主键时，需要启动流程后才有值">
                  <i class="property-tip icon-question" />
                </el-tooltip>
                <span>关联填充字段</span>
              </td>
              <td>
                <eco-select
                  validate="required"
                  v-model="data.options.fillField"
                  :options="tablefields"
                  :props="{ key: 'name', value: 'desc' }"
                  :clearable="true"
                >
                  <template slot-scope="{ options, propKey, propValue }">
                    <el-option-group
                      v-for="group in options"
                      :key="group.name"
                      :label="group.desc"
                    >
                      <el-option
                        v-for="item in group.children.filter(obj => {
                          return filterFields(obj);
                        })"
                        :key="item[propKey]"
                        :label="item[propValue]"
                        :value="item[propKey]"
                      ></el-option>
                      <el-option
                        :key="group.pkKey"
                        label="主键"
                        :value="group.pkKey"
                      ></el-option>
                    </el-option-group>
                  </template>
                </eco-select>
              </td>
              <td>
                <el-select
                  v-model="data.options.bindFilld"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in templateField"
                    :key="item.id"
                    :label="item.desc"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </td>
            </tr>
          </tbody>
        </table>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmDataView()">确 定</el-button>
          <el-button @click="dialogDataViewVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </template>
    <template v-else>
      <div class="property-empty">当前布局字段没有可配置属性</div>
    </template>
    <el-dialog
      title="设置栅格布局样式"
      :visible.sync="dialogStyleVisible"
      append-to-body
      class="urgent-text"
      :before-close="includeStyleNo"
      :close-on-click-modal="false"
      width="600px"
      ><span style="color: red; "
        >编辑的只能为Style样式内容，如：border: 1px solid
        #ccc;&nbsp;&nbsp;border-left: none; &nbsp;&nbsp;border-right:
        none;&nbsp;&nbsp;border-top: none;&nbsp;&nbsp;border-bottom: none;
      </span>
      <el-row style="height:100%">
        <codemirror
          v-model="style"
          :options="cmStyle"
          style="width: 99%;height:100%;"
        ></codemirror>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="includeStyleOk">确 定</el-button>
        <el-button @click="includeStyleNo">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加关联关系"
      :visible.sync="relationVisible"
      append-to-body
      width="600px"
    >
      <el-form :inline="true">
        <el-button type="primary" @click="add">添加</el-button>
      </el-form>
      <el-table style="width: 100%" :data="relations" border>
        <el-table-column type="selection" width="55" />
        <el-table-column label="子表字段">
          <template slot-scope="scope">
            <el-select v-model="scope.row.key_">
              <el-option
                v-for="result in data.list"
                :key="result.key"
                :label="result.name"
                :value="result.name"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="value_" label="主表字段">
          <template slot-scope="scope">
            <el-select v-model="scope.row.value_">
              <el-option
                v-for="result in tablefields[0].children"
                :key="result.id"
                :label="result.name"
                :value="result.path + '.' + result.name"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-delete"
              @click="remove(scope.$index)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="relationVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Draggable from "vuedraggable";
import IconDialog from "@/components/dialog/IconDialog.vue";
import i18nMessageEdit from "@/components/system/I18nMessageEdit";
import { Base64 } from "js-base64";
import utils from "@/eco-ui-util.js";
import form from "@/api/form.js";
const EipDataTemplateSelector = () =>
  import("@/components/selector/EipDataTemplateSelector.vue");

export default {
  name: "layout-property",
  components: {
    Draggable,
    IconDialog,
    i18nMessageEdit,
    EipDataTemplateSelector
  },
  props: ["data", "subTables", "sunTables", "tablefields"],
  data() {
    return {
      customDialogs: [], //对话框列表数据,
      dialogcustDialogVisible: false,
      custDialogprop: {},
      dialogincluddingFileVisible: false,
      pageBtnScriptDialog: false,
      pageBtnScriptBase: "",
      i18nMessageKey: "",
      dialogStyleVisible: false, //编写栅格布局样式对话框
      templateList: [],
      templateField: [],
      dialogDataViewVisible: false, //
      templateShow: false,
      style: "", //栅格布局样式
      styleIndex: "", //栅格布局样式下标
      cmStyle: {
        value: "",
        mode: "style",
        readOnly: false,
        smartIndent: true,
        tabSize: 2,
        theme: "base16-light",
        lineNumbers: true,
        line: true
      },
      relationVisible: false,
      relations: []
    };
  },
  mounted() {
    //回填显示数据视图控件
    if (this.data.ctrlType) {
      if (this.data.templateId) {
        if (this.data.templateId != "") {
          form
            .getBpmDataTemplateById(this.data.templateId, "")
            .then(response => {
              this.templateList.push(response.data);
              this.templateShow = true;
            });
        }
      } else {
        this.templateShow = true;
      }
    }
  },
  watch: {
    templateList: function(newVal, oldVal) {
      if (newVal) {
        let length = newVal.length;
        if (length == 1) {
          //保存boDefAlias
          this.tablefields.forEach(item => {
            if (item.type == "main") {
              this.data.options.boDefAlias = item.boDefAlias;
            }
          });
          this.data.templateKey = newVal[0].alias;
          this.data.templateId = newVal[0].id;
          let data = newVal[0].formField;
          if (data) {
            this.templateField = JSON.parse(data);
          }
        } else if (length == 0) {
          this.templateField = [];
          this.data.templateKey = "";
          this.data.templateId = "";
          this.data.options = {};
          this.data.options.showLabel = true;
        }
      }
    },
    "data.ctrlType": function(newVal, oldVal) {
      if (newVal != oldVal) {
        if (newVal == "dataView") {
          if (this.data.templateId == "" && this.templateList.length > 0) {
            this.templateList = [];
          }
          if (this.data.templateId != "" && this.templateList.length == 0) {
            this.templateShow = false;
            form
              .getBpmDataTemplateById(this.data.templateId, "")
              .then(response => {
                this.templateList.push(response.data);
                this.templateShow = true;
              });
          }
        }
      }
    }
  },
  methods: {
    filterFields(obj) {
      if (obj.nodeType == "sub") {
        return false;
      } else {
        return true;
      }
    },
    //编写栅格布局样式后取消事件
    includeStyleNo() {
      this.style = "";
      this.styleIndex = "";
      this.dialogStyleVisible = false;
    },
    //编写栅格布局样式后确认事件
    includeStyleOk() {
      if (this.style) {
        this.data.columns[this.styleIndex].style = this.style;
      }
      this.style = "";
      this.styleIndex = "";
      this.dialogStyleVisible = false;
    },
    //打开编写栅格布局样式对话框
    handleGridColumnStyle(index) {
      this.styleIndex = index;
      if (this.data.columns[index].style) {
        this.style = this.data.columns[index].style;
      } else {
        this.style = "";
      }
      this.dialogStyleVisible = true;
    },
    autoRunJSScript(type, isBnt) {
      this.BtnScriptType = type;
      let script;
      if (type == 1) {
        //下一步按钮的前置脚本
        script = this.data.options.nextBntjson.preScript;
      }
      this.pageBtnScriptDialog = true;
      if (!script) return;
      this.pageBtnScriptBase = Base64.decode(script);
    },
    pageBtnScriptDialogOk() {
      this.pageBtnScriptDialog = false;
    },
    pageBtnScriptDialogClose() {
      this.pageBtnScriptDialog = false;
    },
    pegeNextIcon(icon) {
      this.data.nextButton.icon = icon;
    },
    pegeBackIcon(icon) {
      this.data.backButton.icon = icon;
    },
    includeFilesOk() {
      this.dialogincluddingFileVisible = false;
      if (this.data.customHeader) {
        this.data.customHeader = Base64.encode(this.data.customHeader, "utf-8");
      }
    },
    includdingFile() {
      this.dialogincluddingFileVisible = true;
      this.data.customHeader = this.data.customHeader
        ? Base64.decode(this.data.customHeader, "utf-8")
        : "";
    },
    unbind(key) {
      for (var item in this.custDialogprop) {
        if (key == item) {
          this.$set(this.custDialogprop, key, "");
          delete this.custDialogprop[key];
        }
      }
    },
    editI18nMessage() {
      this.i18nMessageKey = this.data.options.subTablePath;
      this.$refs.i18nMessageEdit.handleOpen();
    },
    afterSaveI18n(data) {
      data.key = data.key.replace("$", "#");
      this.data.desc = data.key;
      this.data.desc_zh = data.desc;
    },
    // 对话框确定事件
    custDialogOk(isDialog) {
      //对话框返回值
      var mappingConf = [];
      for (var key in this.custDialogprop) {
        mappingConf.push({
          from: key,
          target: [this.custDialogprop[key]]
        });
      }
      this.data.customDialogjson.custDialog.mappingConf = mappingConf;
      this.dialogcustDialogVisible = false;
    },
    custDialogClick() {
      this.dialogcustDialogVisible = true;
      this.custDialogprop = null;
      let tempGroup = {};
      var initConf = this.data.customDialogjson;
      if (initConf.custDialog.mappingConf) {
        for (var i = 0, c; (c = initConf.custDialog.mappingConf[i++]); ) {
          if (!c) continue;
          var target = c.target;
          if (target) target = target.join(",");
          tempGroup[c.from] = target;
        }
      }
      initConf.resultField.forEach(f => {
        if (!tempGroup[f.comment]) {
          tempGroup[f.comment] = "";
        }
      });
      this.custDialogprop = tempGroup;
    },
    //数据视图控件方法
    dataViewClick() {
      this.dialogDataViewVisible = true;
    },
    confirmDataView() {
      this.dialogDataViewVisible = false;
    },
    afterCustomDialogLoadData(data) {
      this.customDialogs = data;
    },
    icons(icon) {
      this.data.customDialogjson.icon = icon;
    },
    changeCustDialog() {
      this.custDialogprop = {};
      this.data.customDialogjson.custDialog.conditions = [];
      if (this.customDialogs.length == 0) return;
      if (this.data.customDialogjson.custDialog.alias == null) {
        this.data.customDialogjson.custDialog.conditions = [];
        return;
      }
      for (var i = 0, d; (d = this.customDialogs[i++]); ) {
        if (d.alias == this.data.customDialogjson.custDialog.alias) {
          var treeData;
          if (d.listDialog && d.listDialog.resultfield) {
            treeData = eval("(" + d.listDialog.resultfield + ")");
            this.data.customDialogjson.custDialog.type = "combiDialog";
          }
          if (d.resultfield) {
            treeData = eval("(" + d.resultfield + ")");
            this.data.customDialogjson.custDialog.type = "custDialog";
          }
          for (var q = 0, f; (f = treeData[q++]); ) {
            f.field = f.comment;
          }
          this.data.customDialogjson.resultField = treeData;
          var conditionList = eval("(" + d.conditionfield + ")");
          this.data.customDialogjson.custDialog.conditions = [];
          //只处理类型等于1的对话框参数（defaultType：1：用户输入，2：固定值 ，3：参数传入）
          if (conditionList && conditionList.length > 0) {
            for (var j = 0, c; (c = conditionList[j++]); ) {
              if (c.defaultType == "3") {
                var has = false;
                if (!has)
                  this.data.customDialogjson.custDialog.conditions.push(c);
              }
            }
          }
        }
      }
    },
    handleGridColumnRemove(index) {
      if (this.data.options.activeNames != undefined) {
        this.data.options.activeNames.remove(this.data.columns[index].idKey);
      }
      this.data.columns.splice(index, 1);
    },
    handleGridColumnAdd(type) {
      if (type == "tab") {
        this.data.columns.push({
          span: "标签页" + (this.data.columns.length + 1),
          list: []
        });
      } else if (type == "page") {
        this.data.columns.push({
          span: "分页" + (this.data.columns.length + 1),
          list: []
        });
      } else if (type == "collapse") {
        this.data.columns.push({
          span: "折叠面板" + (this.data.columns.length + 1),
          idKey: Date.parse(new Date()) + utils.getName(),
          isOpen: false,
          list: []
        });
      } else {
        this.data.columns.push({
          span: "",
          list: []
        });
      }
    },
    switchChange(item) {
      if (eval(item.isOpen)) {
        this.data.options.activeNames.push(item.idKey);
      } else {
        this.data.options.activeNames.remove(item.idKey);
      }
    },
    subTableChange(value, data) {
      this.data.name = data.name;
      this.data.list = [];
      this.data.desc = data.desc;
      this.data.options.subTablePath = data.path;
      this.data.options.relation = data.relation;
    },
    addRelation() {
      this.relationVisible = true;
      this.relations = [];
      this.data.list.forEach(item => {
        if (item.options.mapping) {
          this.relations.push({
            key_: item.name,
            value_: item.options.mapping
          });
        }
      });
    },
    add() {
      this.relations.push({
        key_: "",
        value_: ""
      });
    },
    remove(index) {
      this.relations.splice(index, 1);
    },
    submit() {
      let flag = false;
      let map = new Map();
      this.relations.forEach(item => {
        if (!item.key_ || !item.value_) {
          flag = true;
        }
        map.set(item.key_, item.value_);
      });
      if (flag) {
        this.$message("映射关系不能为空");
        return;
      }
      this.data.list.forEach(item => {
        if (map.has(item.name)) {
          item.options.mapping = map.get(item.name);
        } else {
          delete item.options.mapping;
        }
      });
      this.relationVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/form-editor.scss";

>>> .el-dialog__body {
  padding: 10px !important;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.column-ul {
  list-style: none;
  padding: 0;
  margin: 4px 0 0 0;
}

.column-ul li {
  margin-bottom: 5px;
}

.column-ul .icon-draggable {
  font-weight: bold;
  font-size: 18px;
  cursor: move;
  margin-right: 8px;
}

.grid-remove-button {
  margin-left: 50px;
}

.ghost {
  background: #f56c6c;
  border: 2px solid #f56c6c;
  outline-width: 0;
  height: 3px;
  box-sizing: border-box;
  font-size: 0;
  content: "";
  overflow: hidden;
  padding: 0;
}

.property-empty {
  text-align: center;
  width: 100%;
  margin-top: 150px;
  font-size: 16px;
  color: #ccc;
}
.linkageTable-tr td {
  text-align: center;
}
.custDialog-div {
  height: 28px;
  line-height: 28px;
  margin-bottom: 3px;
}
.custDialog-div .custDialog-btn {
  float: right;
  margin-right: 15px;
}
.custDialog-table td {
  padding: 5px;
}
>>> .custDialog-item {
  margin-bottom: 5px;
}

.basics-property .el-form-item {
  margin-bottom: 0px;
}
.linkageTable-tr td {
  text-align: center;
}
.basics-property >>> .el-form-item {
  margin-bottom: 0px;
}
.basics-label >>> .el-form-item__label {
  text-align: center;
}
</style>
